<template>
  <div>
    <el-dialog class="productTypeDialog" :close-on-click-modal="false" :destroy-on-close="true" custom-class="planWordDialog" :append-to-body="true"
      title="生成操作确认单" :visible.sync="collectionShow" width="45%">
      <div class="Dialog-top">
        <el-form ref="collectionRequest" :rules="rules" :model="collectionRequest" label-width="80px">
          <div class="collection-line">
            <h3>确认项目及收费金额</h3>
            <p class="colletion-p"><el-radio :label="1" v-model="colletionType" @change="changeType">全款{{
              totalPayPrice != '' ? "(" + totalPayPrice + '¥)' : ''
            }}</el-radio></p>
            <p class="colletion-p"><el-radio :label="2" v-model="colletionType" @change="changeType">按项目</el-radio></p>
            <p class="colletion-p" style="padding-left: 60px;">
              <el-checkbox-group v-model="checkList" @change="chooseTypeList">
                <span v-for="(item, index) in stateTotalPayPrice" :key="index">
                  <el-checkbox v-if="item.price > 0" :label="item.state">{{ stockTypeMap[item.state].typeName }}（{{
                    item.price }}¥）</el-checkbox>
                </span>
              </el-checkbox-group>
            </p>
            <p class="colletion-p">
              <el-radio :label="3" v-model="colletionType" @change="changeType">按具体产品</el-radio>
              <el-link type="success" @click="chooseProduct" v-if="!collectionRequest.id">选择产品</el-link>
            </p>
            <p class="colletion-p"><el-radio :label="4" v-model="colletionType" @change="changeType">自定义</el-radio></p>
            <el-form-item label="收费款项" prop="chargingContent" v-if="colletionType == 4">
              <el-input type="textarea" v-model="collectionRequest.chargingContent"></el-input>
            </el-form-item>
            <el-form-item label="收费金额" prop="feeAmount">
              <el-input type="number" v-model="collectionRequest.feeAmount" :disabled="collectionRequest.id"
                @change="changePrice" style="width:200px"></el-input>
              <currency-autocomplete :obj="collectionRequest" :sizeType="'medium'" :styleStr="'margin-left: 0.1rem;'"></currency-autocomplete>
            </el-form-item>
            <p class="colletion-p">
              <el-radio :label="1" v-model="payOrder" :disabled="disabled">客人缴费后系统自动下采购订单</el-radio>
              <el-radio :label="2" v-model="payOrder" :disabled="disabled">客人缴费后，我自己手动下产品采购订单</el-radio>
            </p>
          </div>
          <div class="collection-line">
            <h3>费用说明</h3>
            <el-form-item label="包含" v-if="colletionType == 4">
              <el-input v-model="collectionRequest.contain"></el-input>
            </el-form-item>
            <el-form-item label="退改" v-if="colletionType == 4">
              <el-input v-model="collectionRequest.returnMsg"></el-input>
            </el-form-item>
            <el-form-item label="不含" v-if="colletionType == 4">
              <el-input v-model="collectionRequest.excluding"></el-input>
            </el-form-item>
            <el-form-item label="服务提供方" prop="serviceProvider">
              <el-input v-model="collectionRequest.serviceProvider"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="collectionRequest.contacts"></el-input>
            </el-form-item>
          </div>
          <div class="collection-line">
            <el-form-item label="发票说明">
              <el-input type="textarea" v-model="collectionRequest.invoiceDescription"></el-input>
            </el-form-item>
          </div>
          <div class="collection-line" v-if="text&&collectionRequest.currency=='￥'" style="display: flex;flex-direction: column;">
            <h3>二维码链接</h3>
            <div class="erWeima">
              <!-- <div class="erWeimaBox">
                <p class="erWeimaTitle">h5付款</p>
                <Qr style="text-align: center;display: flex;margin-left: 120px;" :bgSrc="bgSrc" :logoSrc="logoSrc"
                  :text="text"></Qr>
              </div> -->
              <div class="erWeimaBox">
                <p class="erWeimaTitle">小程序付款</p>
                <Qr style="text-align: center;display: flex;margin-left: 120px;" :bgSrc="bgSrc" :logoSrc="logoSrc"
                  :text="text1"></Qr>
              </div>
            </div>
          </div>
          <div v-if="!collectionRequest.id">
            <div style="margin-top: 0.1rem;color: red;" v-if="!(user.officialAccount && user.officialAccount != '')">
              您没有绑定公众号，收不到收款订单结果通知，如需提醒通知，请点击<a style="color:blue" @click="bangding">绑定</a>公众号</div>
          </div>
          <el-form-item class="button" v-if="collectionRequest.id">
            <el-button type="primary" @click="uodateColletion()">保存</el-button>
            <el-button type="primary" @click="addUndderLine()">生成线下收款</el-button>
            <el-button @click="collectionShow = false">关闭</el-button>
          </el-form-item>
          <el-form-item class="button" v-else>
            <el-button type="primary" @click="submitForm('collectionRequest')" v-if="text == ''"
              v-loading.fullscreen.lock="fullscreenLoading">立即生成</el-button>
            <el-button @click="collectionShow = false">关闭</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <add-under-line-pay ref="addUnderLonePay" @getList="getList"></add-under-line-pay>
    <official-account ref="officialAccount" :tipText="'扫描上方二维码绑定公众号通知'" :title="''"></official-account>
    <budget-detail-dialog ref="budgetDetailDialog" :chenckBudget="chenckBudget"
      @chooseProduct="chooseProductSure"></budget-detail-dialog>
  </div>
</template>

<script>
import Qr from "@/components/Qr.vue";
import PayApi from "@/components/Api/pay";
import { mapState } from 'vuex';
import officialAccount from '../../../../components/officialAccount/officialAccount.vue';
import budgetDetailDialog from '../dialog/budgetDetailDialog.vue';
import Api from "@/components/Api/index.js";
import { stockTypeMap } from '@/assets/utils/commonData'
import AddUnderLinePay from '../../../mechanism/components/myDealChild/child/dialog/addUnderLinePay.vue';
import CurrencyAutocomplete from '../../../common/currencyAutocomplete.vue';
export default {
  name: "collection",
  data() {
    return {
      totalPayPrice: '',
      stateTotalPayPrice: [],
      payOrder: null,
      checkList: [],
      colletionType: null,
      logoSrc: require("@/assets/png/planQRLogo.png"),
      bgSrc: "",
      text: "",//h5
      text1: '',//小程序
      disabled: false,
      stockTypeMap,
      rules: {
        chargingContent: [
          { required: true, message: '请输入收费内容', trigger: 'blur' }
        ],
        feeAmount: [
          { required: true, message: '请输入收费金额', trigger: 'blur' }
        ],
        serviceProvider: [
          { required: true, message: '服务提供方不能为空', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '联系人不能为空', trigger: 'blur' }
        ]
      },
      user: {},
      collectionShow: false,
      collectionRequest: {
        chargingContent: '',
        oldfeeAmout: '',
        feeAmount: '',
        // 服务提供方
        serviceProvider: '',
        // 包含
        contain: null,
        // 退改
        returnMsg: null,
        // 不含
        excluding: null,
        // 联系人
        contacts: '',
        // 发票说明
        invoiceDescription: null,
        planId: null,
        budgetMainId: null,
        currency:'￥',
      },
      chenckBudget: {},
      checkProductList: [],
      fullscreenLoading: false,
    }
  },
  components: { Qr, officialAccount, budgetDetailDialog, AddUnderLinePay ,CurrencyAutocomplete},
  methods: {
    chooseProduct() {
      this.$refs.budgetDetailDialog.openDialog(2)
    },
    uodateColletion() {
      new PayApi("pay").update(this.collectionRequest).then(res => {
        if (res.status == 200) {
          this.collectionShow = false
          this.$emit("refresh")
        }
      }).catch(e => {
        this.fullscreenLoading = false
      })
    },
    addUndderLine() {
      this.$refs.addUnderLonePay.openDailog({
        id: this.collectionRequest.id,
        feeAmount: this.collectionRequest.feeAmount
      })
    },
    chooseProductSure(data) {
      var price = 0
      this.checkProductList = []
      data.forEach(ee => {
        if (ee.checkFlag) {
          this.checkProductList.push(ee.id)
          price = price + (ee.ratio * ee.stockNumber * ee.rate)
        }
      })
      this.collectionRequest.feeAmount = price
      this.collectionRequest.oldfeeAmout = this.collectionRequest.feeAmount
      this.colletionType = 3
    },
    bangding() {
      let userId = this.user.id
      let url = process.env["VUE_APP_ACCOUNT_H5_SERVE"] + `?userId=${userId}`
      this.$refs.officialAccount.initClick(url)
    },
    chooseTypeList(e) {
      if (this.checkList.length > 0) {
        this.colletionType = 2
        this.payOrder = 1
        this.disabled = false
      }
      this.collectionRequest.feeAmount = this.countTypeListPrice()
      this.collectionRequest.oldfeeAmout = this.collectionRequest.feeAmount
    },
    countTypeListPrice() {
      var price = 0;
      this.stateTotalPayPrice.forEach(ee => {
        if (this.checkList.findIndex(e => e == ee.state) != -1) {
          price = Number(ee.price) + price
        }
      })
      return price;
    },
    changePrice() {
      if (this.collectionRequest.feeAmount < this.collectionRequest.oldfeeAmout) {
        this.payOrder = 2
        this.disabled = true
      }
    },
    changeType() {
      if (this.colletionType == 1) {
        this.collectionRequest.feeAmount = this.totalPayPrice
        this.collectionRequest.oldfeeAmout = this.collectionRequest.feeAmount
        this.payOrder = 1
        this.disabled = false
      } else if (this.colletionType == 2) {
        this.collectionRequest.feeAmount = this.countTypeListPrice()
        this.collectionRequest.oldfeeAmout = this.collectionRequest.feeAmount
        this.payOrder = 1
        this.disabled = false
      } else if (this.colletionType == 3) {
        this.collectionRequest.feeAmount = 0
        this.collectionRequest.oldfeeAmout = this.collectionRequest.feeAmount
        this.payOrder = 1
        this.disabled = false
      } else {
        this.payOrder = 2
        this.disabled = true
      }
      if (this.colletionType != 2) {
        this.checkList = []
      }
    },
    init(data) {
      this.collectionRequest.id=null
      this.chenckBudget = data
      this.totalPayPrice = 0, // ?
      this.stateTotalPayPrice = []
      this.collectionRequest.feeAmount = null
      this.payOrder = null // ?
      this.disabled = false // ?
      this.text = ''
      this.text1 = ''
      this.colletionType = null;
      this.checkList = []
      data.planDayList.forEach(element => {
        if(element.budgetDetails){
          element.budgetDetails.forEach(e => {
            var index = this.stateTotalPayPrice.findIndex(ee => ee.state == e.state)
            if (index == -1) {
              this.stateTotalPayPrice.push({
                state: e.state,
                price: 0,
              })
              index = this.stateTotalPayPrice.length - 1
            }
            e.details.forEach(ee => {
              this.totalPayPrice = this.totalPayPrice + (ee.ratio * ee.stockNumber * ee.rate)
              this.stateTotalPayPrice[index].price = this.stateTotalPayPrice[index].price + (ee.ratio * ee.stockNumber * ee.rate)
            })
          })
        }
      });
      this.totalPayPrice = this.totalPayPrice.toFixed(2)
      this.stateTotalPayPrice.forEach(ee => {
        ee.price = ee.price.toFixed(2)
      })
      this.collectionShow = true
      this.collectionRequest.serviceProvider = this.$store.state.userInfor.companyName
      this.collectionRequest.contacts = this.$store.state.userInfor.name + " " + this.$store.state.userInfor.phoneNumber
      new Api("user").selectUserInfo({ id: this.$store.state.userInfor.userId }).then(res => {
        if (res.status == 200) {
          this.user = res.data
        }
      })
    },
    beforeOpen(item) {
      this.collectionRequest = item
      this.collectionShow = true
      this.colletionType = this.collectionRequest.collectionType
      this.disabled = true
    },
    getList() {
      this.collectionShow = false
      getOrderPlanInfo(this.$store.state.planId, null)
    },
    submitForm(formName) {
      this.fullscreenLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.collectionRequest.planId = this.planId;
          this.collectionRequest.budgetMainId = this.budgetMainId;
          this.collectionRequest.collectionType = this.colletionType
          if (this.colletionType == 1 || this.colletionType == 2) {
            this.checkProductList = []
            this.chenckBudget.planDayList.forEach(element => {
              element.budgetDetails.forEach(e => {
                if (this.colletionType == 1 || (this.colletionType == 2 && this.checkList.indexOf(e.state) != -1)) {
                  e.details.forEach(ee => {
                    this.checkProductList.push(ee.id)
                  })
                }
              })
            });
          } else if (this.colletionType == 4) {
            this.checkProductList = []
          }
          this.collectionRequest.collectionLinkData = JSON.stringify(this.checkProductList)
          this.collectionRequest.isAutoOrder = this.payOrder
          this.collectionRequest.id = null
          new PayApi("pay").addCollection(this.collectionRequest).then(res => {
            if (res.status == 200) {
              let uri = process.env["VUE_APP_COLLECTION_H5_SERVE"]
              this.text = uri + `?type=2&collectionId=${res.data.collectionId}&ciphertext=${res.data.ciphertext}`
              // this.text1 = `${process.env["VUE_APP_INVOICE_H5_SERVE"]}?url=` + encodeURIComponent(uri)
              this.text1 = process.env["VUE_APP_INVOICE_H5_SERVE"] + `?type=2&collectionId=${res.data.collectionId}&ciphertext=${res.data.ciphertext}`
              this.fullscreenLoading = false
              this.collectionRequest.id = res.data.collectionId
            }
          }).catch(e => {
            this.fullscreenLoading = false
          })
        } else {
          return false;
        }
      });
    },
  },
  // 计算属性 类似于 data 概念
  computed: {
    ...mapState(['budgetMainId']),
    ...mapState(['planId'])
  },
  // 监控 data 中的数据变化
  watch: {},
  //过滤器
  filters: {},
  // 生命周期 - 创建之前
  beforeCreate() {
  },
  // 生命周期 - 创建完成（可以访问当前this 实例）
  created() {
  },
  // 生命周期 - 挂载之前
  beforeMount() {
  },
  // 生命周期 - 挂载完成（可以访问 DOM 元素）
  mounted() {
  },
  // 生命周期 - 更新之前
  beforeUpdate() {
  },
  // 生命周期 - 更新之后
  updated() {
  },
  // 生命周期 - 销毁之前
  beforeDestroy() {
  },
  // 生命周期 - 销毁完成
  destroyed() {
  },
  // 如果页面有 keep-alive 缓存功能,这个函数会触发
  //进入的时候触发
  activated() {
  },
  //离开的时候触发
  deactivated() {
  },
}
</script>

<style scoped lang="scss">
/deep/ .el-form-item__label {
  width: 120px !important;
}

/deep/ .el-input {
  width: 90%;
}

/deep/ .el-textarea {
  width: 90%;
}

.button {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.colletion-p {
  padding: 0 40px;
  margin-bottom: 10px;
}

.collection-line {
  padding: 5px;
  background: aliceblue;
  margin-bottom: 3px;

  .erWeima {
    display: flex;
    margin-bottom: 0.1rem;

    .erWeimaBox {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .erWeimaTitle {
        margin-left: 120px;
        margin-bottom: 0.1rem;
        font-size: 0.2rem;
        color: #CB582E;
        font-weight: bold;
      }
    }
  }

  >h3 {
    margin-bottom: 10px;
  }
}

.costDescription {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
